import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Endpoints } from "src/app/shared/config/endpoints";
import { GeneralService } from "../general.service";
import { bulkSMSUnitPaymentPayload } from "src/app/models/settings/bulkSMS";
import { SignupLoginService } from "../signupLogin.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { Observable, Subject, BehaviorSubject } from "rxjs";
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';

declare var PaystackPop: any;

@Injectable({
  providedIn: "root",
})
export class BulkMessagesService {
  orgId: number;
  userId: number;
  callbackObservable = new Subject();
  private server_uri = `${this.endpoints.communicationsEndpoint}/mailing`;
  private settings_server = this.endpoints.settingsUrl;
  private comms_service = this.endpoints.commsServiceUrl;

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    private store: Store<AppState>,
    private gs: GeneralService,
  ) {
    //
    this.store.select('userInfo').subscribe(info => {
      if (Object.keys(info).length) {
        this.orgId = info.organization.id
        this.userId = info.user.id;
      }
    })
  }

  public sendMessage(data: any) {
    const { orgId, userId } = this;
    const payload = {
      ...data,
      orgId,
      userId,
    }
    return this.http.post(`${this.settings_server}/settingsservice-notch-crm/sendBulkSMS`, payload);
  }
  public getSMSUnit() {
    const { orgId } = this;
    return this.http.get(
      `${this.settings_server}/settingsservice-notch-crm/${orgId}/getTwoFactorSMSByCompany`
    );
  }

  public getCompanyIntegrations() {
    const { orgId } = this;
    return this.http.get(
      `${this.settings_server}/settingsservice-notch-crm/${orgId}/getIntegrationsByCompany`
    );
  }

  public updateSMSUnits(payload) {
    return this.http.post(
      `${this.settings_server}/settingsservice-notch-crm/saveTwoFactorSMS`,
      payload
    );
  }

  payWithPaystack(payload: bulkSMSUnitPaymentPayload) {
    var handler = PaystackPop.setup({
      key: environment.paystackKey,
      email: payload.email,
      amount: payload.amount * 100,
      currency: payload.currency,
      ref: "" + Math.floor(Math.random() * 1000000000 + 1),
      metadata: payload.metadata,
      callback: (response) => {
        this.callbackObservable.next({ payload, response });
        console.log('***paystack',response);
        if(response && response.reference){
          this.gs.sweetAlertSuccess('SMS TOP UP','SMS unit addition in progress, please check back shortly');
        }
      },
      onClose: function () {
        // alert("window closed");
      },
    });
    handler.openIframe();
  }

  paystackVerification(reference) {
    return this.http.get(
      `${this.comms_service}/mailing/bulk-sms/verify/paystack/${reference}`
    );
  }
}
